import validator from 'validator';
import Color from '../utils/Color';
export function isNumber(value) {
    return (typeof value == 'number' || value instanceof Number);
}
export function isString(value) {
    return (typeof value === 'string' || value instanceof String);
}
export function isBoolean(value) {
    return (typeof value === 'boolean' || value instanceof Boolean);
}
export function isDate(value) {
    return ((typeof value === 'object' && typeof value.getMonth === 'function') || value instanceof Date);
}
export function isColor(value) {
    return (value instanceof Color);
}
export function isArrayBuffer(value) {
    return (value instanceof ArrayBuffer);
}
export function isEmail(value) {
    if (isString(value)) {
        return validator.isEmail(value);
    }
    return false;
}
export function isUrl(value) {
    if (isString(value)) {
        return validator.isURL(value);
    }
    return false;
}
export function isPhone(value) {
    if (isString(value)) {
        return validator.isMobilePhone(value);
    }
    return false;
}
export function isBirthdayFormat(value) {
    const regex = /^(19|20)\d\d[/](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])$/gm;
    return regex.test(value);
}
export function isEmailArray(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const idx in value) {
        if (!isEmail(value[idx])) {
            return false;
        }
    }
    return true;
}
export function isStringArray(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const idx in value) {
        if (!isString(value[idx])) {
            return false;
        }
    }
    return true;
}
export function isStringMap(value) {
    if (typeof value !== 'object') {
        return false;
    }
    for (const prop in value) {
        if (!isString(prop)) {
            return false;
        }
    }
    return true;
}
export function isStringMapArray(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const idx in value) {
        if (!isStringMap(value[idx])) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=TypeChecking.js.map